import {AuthService} from '../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { Role } from 'app/shared/models/role';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css']
})
export class SsoComponent implements OnInit {
  private _ssoFailed:boolean;
  private _debugAlerts:boolean;
  private _storageAccessRequired:boolean;
  constructor(private route:ActivatedRoute, 
    private dacConfig:DacConfig,
    private router:Router, private authService:AuthService,
    private alertService:AlertService) { 
      this._ssoFailed = false;
      this._debugAlerts = false;
      this.log("SsoComponent");
      this._storageAccessRequired = false;
  }

  private log(msg) {
    if (this._debugAlerts) {
      this.alertService.error(msg);
    }
    else {
      console.log(msg);
    }
  }

  public get title() {
    return this.dacConfig.applicationTitle;
  }

  public get isSeamless() {
    return this.dacConfig.seamlessMode;
  }

  public get ssoFailed() {
    return this._ssoFailed;
  }

  public get storageAccessRequired() {
    return this._storageAccessRequired;
  }
  ngInit() {
    this.route.queryParams.subscribe((params) => {
      this.log("Query params are subscribed inside ngInit()");
    });
    this.alertService.error("show something here");
  }

  ngAfterViewInit() {
    this.loadSSO(); // for now we just load the sso and don't deal with the storage access stuff.
  }

  public grantStorageAccess() {
    // @ts-ignore
    var storageAccessGranted = document.requestStorageAccess();
    storageAccessGranted.then((isAccessGranted) => {
      if (isAccessGranted === true || isAccessGranted === undefined) {
        this._storageAccessRequired = false;
        this.loadSSO();
      }
      else {
        this.alertService.error("Storage access is required to use this service");
      }
    })
    .catch((reason) => {
      console.error(reason);
      this.alertService.error(reason);
      this.alertService.error("Storage access is required to use this service");
    });
  }

  public requestStorageAccess() {
    let storageAccessGranted = Promise.resolve(true);
    if (!window.document['requestStorageAccess']) {
      console.error("requestStorageAccess() called when window.Document.requestStorageAccess does not exist");
    } else {
      storageAccessGranted = window.document['requestStorageAccess']();
    }
    storageAccessGranted.then((isAccessGranted) => {
      if (isAccessGranted) {
        this.loadSSO();
      }
      else {
        this.loadStorageAccessNeeded();
      }
    });
  }

  public loadStorageAccessNeeded() {
    this._storageAccessRequired = true;
  }

  private loadSSO() {
    this.log("SsoComponent ngAfterViewInit ");
    let time = new Date();
    this.log("Inside the ngAfterViewInt just before subscribe of query params");
    this.route.queryParams.subscribe((params) => {
     
      this.authService.authenticateSSO(params.RelayState)
      .then((userResp) => {
        this.log("User response is: " + JSON.stringify(userResp));
        let route = userResp.redirectUrl;
        if (userResp.issuer) {
          this.dacConfig.setupSSOIssuerForSession(userResp.issuer);
        }
        if (!route) {
          route = userResp.role == Role.Client ? "/assessments/dashboard/" : "/admin/dashboard/";
        }
        // so we don't just quickly flash through give a second to 
        if (new Date().getTime() < (time.getTime() +1000)) {
          setTimeout(() => {
            this.router.navigate([route]);
          }, 1000);
        }
        else {
          this.router.navigate([route]);
        } })
      .catch((error) => {
        this.log(error);
        // TODO: stephen if there is no error we should display something here...
        if (error.redirectURL) {
          window.location.href = error.redirectURL;
        }
        else {
          this._ssoFailed = true;
        }
      });
    });
  }

  ngOnInit() {
    
  }

  // TODO: stephen abstract this all into a footer component.

  get supportPhone() {
    return this.dacConfig.supportPhone;
  }

  get supportEmail() {
    return this.dacConfig.supportEmail;
  }

  get mailLink() {
    return "mailto:" + this.supportEmail;
  }
  get phoneLink() {
    return "tel:" + this.supportPhone;
  }

  get copyrightTitle() {
    return this.dacConfig.copyrightTitle;
  }
  get copyrightURL() {
    return this.dacConfig.copyrightURL;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/login/sso/sso.component.ts